import type { FilterFn, Row } from '@tanstack/react-table';

export const filterFn: FilterFn<any> = (
  row: Row<any>,
  columnId: string,
  filterValue: any[],
) => {
  if (!filterValue?.length) return true;
  const rowValue = row.getValue(columnId);
  return filterValue.includes(rowValue);
};
